import { useCallback, useEffect, useRef, useState } from 'react';

import { AdyenCheckout, CoreConfiguration } from '@adyen/adyen-web';

import { useCheckout } from '../../../../../hooks/use-checkout';
import { AdyenConfig, PaymentMethod } from '../../../../../contracts';

type Core = Awaited<ReturnType<typeof AdyenCheckout>>;

export function useAdyenCheckout(selectedPaymentMethod?: PaymentMethod) {
  const isAdyenWebInitialized = useRef<boolean>(false);
  const [checkoutInstance, setCheckoutInstance] = useState<Core | undefined>();
  const { checkoutData } = useCheckout();

  const adyenConfig = selectedPaymentMethod?.publicConfig;
  const paymentMethodsConfig = selectedPaymentMethod?.paymentMethodConfig || {};

  const loadAdyen = useCallback(async (adyenConfig: AdyenConfig) => {
    const configuration: CoreConfiguration = {
      paymentMethodsResponse: {
        paymentMethods: [
          {
            brands: [
              'visa',
              'mc',
              'amex',
              'discover',
              'cup',
              'maestro',
              'diners',
              'hipercard',
              'jcb',
            ],
            name: 'Cards',
            type: 'scheme',
          },
          paymentMethodsConfig,
        ],
      },
      environment: adyenConfig.env as CoreConfiguration['environment'],
      countryCode: checkoutData?.customer.geoLocator.countryCode2,
      showPayButton: false,
      clientKey: adyenConfig.clientKey,
      onError: (error, component) => {
        console.log('onError', { error, component });
      },
    };
    try {
      const checkoutInstance = await AdyenCheckout(configuration);
      setCheckoutInstance(checkoutInstance);
    } catch (error) {
      console.log({ error });
    }
  }, []);

  useEffect(() => {
    if (!isAdyenWebInitialized.current && adyenConfig) {
      isAdyenWebInitialized.current = true;
      loadAdyen(adyenConfig as AdyenConfig);
    }
  }, [loadAdyen, adyenConfig]);

  return {
    checkoutInstance,
  };
}
